import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Typography } from "antd";
import { Boxes } from "lucide-react";

import MastersTabBar, { MASTER_TABS } from "../../components/Common/MastersTabBar/MastersTabBar";
import InternalOrderMaster from "../InternalOrderMaster/InternalOrderMaster";
import IoIndasDataMapping from "../IoIndasDataMapping/IoIndasDataMapping";
import IoUnitMapping from "../IoUnitMapping/IoUnitMapping";
import IoAllocation from "../IoAllocation/IoAllocation";
import PmgProjectsPage from "../PMG/PmgProjectsPage";
import MasterUploads from "../MasterUploads/MasterUploads";

const { Title, Text } = Typography;

const TAB_COMPONENTS = {
    internalOrderMaster: InternalOrderMaster,
    orderAllocationUpdation: IoIndasDataMapping,
    ioUnitMapping: IoUnitMapping,
    ioAllocation: IoAllocation,
    projectMilestone: PmgProjectsPage,
    masterUploads: MasterUploads,
};

export default function Masters() {
    const location = useLocation();
    const [activeTab, setActiveTab] = useState(location.state?.tab || MASTER_TABS[0].id);
    const ActiveComponent = TAB_COMPONENTS[activeTab];

    return (
        <div className="min-h-screen bg-slate-50 px-6 py-3">

            {/* Header */}

            <div className="mb-8">
                <Title
                    level={2}
                    style={{ marginBottom: 6 }}
                    className="!flex !items-center gap-2"
                >
                    <Boxes size={38} className="text-blue-600 bg-blue-100 rounded-md p-1 " />
                    Masters
                </Title>

                <Text type="secondary">
                    Manage internal order, allocation, unit mapping and milestone masters.
                </Text>
            </div>

            {/* Tabs */}

            <MastersTabBar activeId={activeTab} onSelect={setActiveTab} />

            {/* Active Master Content */}

            <ActiveComponent />

        </div>
    );
}
